
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4cc0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4cc0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("efyfk", function(module, exports) {
"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ status = "idle";
    score = 0;
    constructor(board = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ]){
        this.board = board;
    }
    moveLeft() {
        if (this.getStatus() !== "playing") return;
        const moved = this.processLeftMoveWithoutRendering();
        if (moved) this.addRandomTile();
        this.updateStatus();
    }
    processLeftMoveWithoutRendering() {
        let moved = false;
        for(let row = 0; row < 4; row++){
            const originalRow = [
                ...this.board[row]
            ];
            const newRow = this.mergeRowByPriority(originalRow);
            if (!this.arraysEqual(originalRow, newRow)) {
                moved = true;
                this.board[row] = newRow;
            }
        }
        return moved;
    }
    mergeRowByPriority(row) {
        let tiles = row.filter((val)=>val !== 0);
        for(let i = 0; i < tiles.length - 1; i++)if (tiles[i] === tiles[i + 1]) {
            tiles[i] *= 2;
            this.score += tiles[i];
            tiles[i + 1] = 0;
            i++;
        }
        tiles = tiles.filter((val)=>val !== 0);
        while(tiles.length < 4)tiles.push(0);
        return tiles.slice(0, 4);
    }
    moveRight() {
        if (this.getStatus() !== "playing") return;
        this.reverseRows();
        const moved = this.processLeftMoveWithoutRendering();
        this.reverseRows();
        if (moved) this.addRandomTile();
        this.updateStatus();
    }
    moveUp() {
        if (this.getStatus() !== "playing") return;
        this.board = this.transpose(this.board);
        const moved = this.processLeftMoveWithoutRendering();
        this.board = this.transpose(this.board);
        if (moved) this.addRandomTile();
        this.updateStatus();
    }
    moveDown() {
        if (this.getStatus() !== "playing") return;
        this.board = this.transpose(this.board);
        this.reverseRows();
        const moved = this.processLeftMoveWithoutRendering();
        this.reverseRows();
        this.board = this.transpose(this.board);
        if (moved) this.addRandomTile();
        this.updateStatus();
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.board.map((row)=>[
                ...row
            ]);
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.status;
    }
    updateStatus() {
        for(let row = 0; row < 4; row++){
            for(let col = 0; col < 4; col++)if (this.board[row][col] === 2048) {
                this.status = "win";
                return;
            }
        }
        if (this.canMakeMove()) this.status = "playing";
        else this.status = "lose";
    }
    /**
   * Starts the game.
   */ start() {
        this.status = "playing";
        const getRandomPosition = ()=>{
            const row = Math.floor(Math.random() * 4);
            const col = Math.floor(Math.random() * 4);
            return [
                row,
                col
            ];
        };
        const getRandomValue = ()=>{
            return Math.random() < 0.1 ? 4 : 2;
        };
        const [row1, col1] = getRandomPosition();
        this.board[row1][col1] = getRandomValue();
        let row2, col2;
        do [row2, col2] = getRandomPosition();
        while (row2 === row1 && col2 === col1);
        this.board[row2][col2] = 2;
        this.updateStatus();
    }
    /**
   * Resets the game.
   */ restart() {
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++)this.board[i][j] = 0;
        this.status = "idle";
        this.score = 0;
    }
    addRandomTile() {
        const emptyCells = [];
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 4; j++)if (this.board[i][j] === 0) emptyCells.push([
                i,
                j
            ]);
        }
        if (emptyCells.length === 0) return;
        const [row, col] = emptyCells[Math.floor(Math.random() * emptyCells.length)];
        const value = Math.random() < 0.1 ? 4 : 2;
        this.board[row][col] = value;
    }
    canMakeMove() {
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            if (this.board[i][j] === 0) return true;
            if (j < 3 && this.board[i][j] === this.board[i][j + 1]) return true;
            if (i < 3 && this.board[i][j] === this.board[i + 1][j]) return true;
        }
        return false;
    }
    reverseRows() {
        for(let i = 0; i < 4; i++)this.board[i].reverse();
    }
    transpose(matrix) {
        return matrix[0].map((_, colIndex)=>matrix.map((row)=>row[colIndex]));
    }
    arraysEqual(a, b) {
        return a.length === b.length && a.every((val, i)=>val === b[i]);
    }
}
module.exports = $a5fd07fa01589658$var$Game;

});

"use strict";

// Uncomment the next lines to use your game instance in the browser
document.addEventListener("DOMContentLoaded", ()=>{
    const Game = (parcelRequire("efyfk"));
    const game = new Game();
    const button = document.querySelector(".button");
    const gameScore = document.querySelector(".game-score");
    const startMessage = document.querySelector(".message-start");
    const winMessage = document.querySelector(".message-win");
    const loseMessage = document.querySelector(".message-lose");
    button.addEventListener("click", ()=>{
        if (button.classList.contains("start")) {
            button.classList.remove("start");
            button.classList.add("restart");
            button.textContent = "Restart";
            game.start();
            $09e991522ca7e64e$var$renderBoard(game.getState());
            document.addEventListener("keydown", (e)=>{
                const keyName = e.key;
                if (game.getStatus() === "lose") {
                    loseMessage.classList.remove("hidden");
                    return;
                }
                if (game.getStatus() === "win") {
                    winMessage.classList.remove("hidden");
                    return;
                }
                if (keyName === "ArrowRight") {
                    game.moveRight();
                    $09e991522ca7e64e$var$renderBoard(game.getState());
                }
                if (keyName === "ArrowLeft") {
                    game.moveLeft();
                    $09e991522ca7e64e$var$renderBoard(game.getState());
                }
                if (keyName === "ArrowUp") {
                    game.moveUp();
                    $09e991522ca7e64e$var$renderBoard(game.getState());
                }
                if (keyName === "ArrowDown") {
                    game.moveDown();
                    $09e991522ca7e64e$var$renderBoard(game.getState());
                }
                gameScore.textContent = game.getScore();
                if (game.getStatus() === "win") winMessage.classList.remove("hidden");
                else if (game.getStatus() === "lose") loseMessage.classList.remove("hidden");
            });
            if (button.classList.contains("restart") && startMessage) startMessage.classList.add("hidden");
        } else {
            button.classList.remove("restart");
            button.classList.add("start");
            button.textContent = "Start";
            if (!winMessage.classList.contains("hidden")) winMessage.classList.add("hidden");
            if (!loseMessage.classList.contains("hidden")) loseMessage.classList.add("hidden");
            gameScore.textContent = game.getScore();
            game.restart();
            $09e991522ca7e64e$var$renderBoard(game.getState());
            if (button.classList.contains("start") && startMessage) startMessage.classList.remove("hidden");
        }
    });
});
function $09e991522ca7e64e$var$renderBoard(state) {
    const rows = document.querySelectorAll(".game-field tbody tr");
    for(let i = 0; i < 4; i++){
        const cells = rows[i].querySelectorAll("td");
        for(let j = 0; j < 4; j++){
            cells[j].textContent = state[i][j] === 0 ? "" : state[i][j];
            cells[j].classList.forEach((cl)=>{
                if (cl.startsWith("field-cell--")) cells[j].classList.remove(cl);
            });
            if (state[i][j] !== 0) cells[j].classList.add(`field-cell--${state[i][j]}`);
        }
    }
}


//# sourceMappingURL=index.c170c855.js.map
